<!-- <div id="sr-widget" data-sr-widget="headToHead.button" data-sr-match-id="18428096"></div> -->
<!-- <div class="widgetcont">
  <div id="sr-widget"></div>
</div> -->

<div class="head-to-head-wrap" (click)="closeWidget()">
  <div class="widgetcont" id="headToHeadWrap"(click)="$event.stopPropagation();" >
    <div><div class="sr-widget"></div></div>
  </div>
</div>
